const getters = {};

getters.list = state => state.list;
getters.active = state => state.active;

getters.apiKey = (state) => {
  const key = state.active.config;
  if (typeof (key) === 'object') return '';

  return key;
};

export default getters;



// WEBPACK FOOTER //
// ./src/screens/Account/store/getters.js